import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useMe } from '../hooks/useApi';
import { useAuth } from '../stores/auth';

/**
 * Página puente entre el redirect del OAuth callback del backend y la app.
 * Hace `GET /auth/me` para hidratar la cookie en el cliente y redirige a /projects.
 */
export function AuthCallbackPage() {
  const { data, isLoading, error } = useMe();
  const setUser = useAuth((s) => s.setUser);
  const navigate = useNavigate();

  useEffect(() => {
    if (data) {
      setUser(data);
      navigate('/projects', { replace: true });
    }
  }, [data, setUser, navigate]);

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center h-full">
        <div className="text-red-400">Error de autenticación: {(error as Error).message}</div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center h-full text-slate-400">
      {isLoading ? 'Conectando con tu cuenta…' : 'Redirigiendo…'}
    </div>
  );
}
